module.exports = __webpack_public_path__ + "static/media/seal-csm.c1bb7365.png";